// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__YWsDE","textDiv":"HeaderCartButton_textDiv__bK4Z8","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__M07E4"};